var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qy-group-dinner-config-pane" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.activityId ? "编辑活动" : "新增活动")),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: { model: _vm.form, "label-width": "140px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动标题", prop: "activityName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { placeholder: "请输入活动标题" },
                    model: {
                      value: _vm.form.activityName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "activityName", $$v)
                      },
                      expression: "form.activityName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "适用场景", prop: "scenes" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.scenes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "scenes", $$v)
                        },
                        expression: "form.scenes",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v("堂食"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _vm._v("自提"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "3" } }, [
                        _vm._v("外卖"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间", prop: "activityTimeRange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "420px" },
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.form.activityTimeRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "activityTimeRange", $$v)
                      },
                      expression: "form.activityTimeRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "满减类型", prop: "discountSubType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.discountSubType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "discountSubType", $$v)
                        },
                        expression: "form.discountSubType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("满额减"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("满额折"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("满份减"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 4 } }, [
                        _vm._v("满份折"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "起订金额" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { type: "number", placeholder: "请输入起订金额" },
                      model: {
                        value: _vm.form.minAmount,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "minAmount", $$v)
                        },
                        expression: "form.minAmount",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("元")])],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#999",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("订单金额需满足此条件才能下单")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "起订份数" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { type: "number", placeholder: "请输入起订份数" },
                      model: {
                        value: _vm.form.minQuantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "minQuantity", $$v)
                        },
                        expression: "form.minQuantity",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("份")])],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#999",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("订单份数需满足此条件才能下单")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "团餐规则说明" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder:
                        "请输入团餐规则说明，如：需提前一天预订、满10人起订等",
                    },
                    model: {
                      value: _vm.form.ruleDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ruleDescription", $$v)
                      },
                      expression: "form.ruleDescription",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "可预订日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "420px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.bookingDateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "bookingDateRange", $$v)
                      },
                      expression: "form.bookingDateRange",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#999",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("设置可预订的日期范围")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "可预订时段" } }, [
                _c(
                  "div",
                  { staticClass: "booking-time-range" },
                  [
                    _c("el-time-picker", {
                      staticClass: "time-picker-start",
                      attrs: {
                        placeholder: "开始时间",
                        format: "HH:mm:ss",
                        "value-format": "HH:mm:ss",
                      },
                      model: {
                        value: _vm.form.bookingStartTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bookingStartTime", $$v)
                        },
                        expression: "form.bookingStartTime",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-separator" }, [
                      _vm._v("至"),
                    ]),
                    _vm._v(" "),
                    _c("el-time-picker", {
                      staticClass: "time-picker-end",
                      attrs: {
                        placeholder: "结束时间",
                        format: "HH:mm:ss",
                        "value-format": "HH:mm:ss",
                      },
                      model: {
                        value: _vm.form.bookingEndTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bookingEndTime", $$v)
                        },
                        expression: "form.bookingEndTime",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-tip" }, [
                  _vm._v("设置每日可预订的时间段，如 06:00:00 至 18:00:00"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分享卡片图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "shareImageUpload",
                      staticClass: "share-image-uploader",
                      attrs: {
                        action: "#",
                        "show-file-list": false,
                        "on-change": _vm.handleShareImageChange,
                        "before-upload": _vm.beforeShareImageUpload,
                        "auto-upload": false,
                        accept: "image/jpeg,image/jpg,image/png,image/gif",
                      },
                    },
                    [
                      _vm.shareImagePreviewUrl || _vm.form.shareImageUrl
                        ? _c("img", {
                            staticClass: "share-image-preview",
                            attrs: {
                              src:
                                _vm.shareImagePreviewUrl ||
                                _vm.getImageUrl(_vm.form.shareImageUrl),
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "share-image-upload-placeholder" },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("点击上传图片")]),
                            ]
                          ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tips" }, [
                    _c("div", [_vm._v("建议尺寸：500x400像素")]),
                    _vm._v(" "),
                    _c("div", [_vm._v("支持格式：jpg、png、gif")]),
                    _vm._v(" "),
                    _c("div", [_vm._v("大小限制：不超过2MB")]),
                  ]),
                  _vm._v(" "),
                  _vm.form.shareImageUrl
                    ? _c(
                        "div",
                        { staticClass: "image-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.handleRemoveShareImage },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "阶梯满减配置",
                    prop: "xyGroupDinnerConfigDetailEntities",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.form.xyGroupDinnerConfigDetailEntities,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: _vm.getThresholdLabel, width: "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      type: "number",
                                      placeholder: "请输入",
                                    },
                                    model: {
                                      value: scope.row.minAmount,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "minAmount", $$v)
                                      },
                                      expression: "scope.row.minAmount",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v(_vm._s(_vm.getThresholdUnit)),
                                    ]),
                                  ],
                                  2
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: _vm.getDiscountLabel, width: "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      type: "number",
                                      placeholder: "请输入",
                                      step: _vm.isDiscountType ? 0.1 : 1,
                                      min: _vm.isDiscountType ? 1 : 0,
                                      max: _vm.isDiscountType ? 10 : null,
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.handleDiscountBlur(
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.discountAmount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "discountAmount",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.discountAmount",
                                    },
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v(_vm._s(_vm.getDiscountUnit)),
                                    ]),
                                  ],
                                  2
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeDiscountRule(
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  删除\n                "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.addDiscountRule },
                    },
                    [_vm._v("\n            + 添加阶梯\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleCancel } }, [
                    _vm._v("取消"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }